import * as PIXI from 'pixi.js';
import { ParentMixin } from '../core/parentMixin';
import { UpdateFlowMixin } from '../core/updateFlowMixin';
import { SerializableMixin } from '../core/serializableMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
} from '../core/attributes';
import { Config } from '../video-data/config';

export class DynamicCircleConfigurator extends UpdateFlowMixin(
    ParentMixin(SerializableMixin(PIXI.utils.EventEmitter)),
) {
    override _name = 'dynamicCircleConfigurator';
    override _classType = 'DynamicCircleConfigurator';
    readonly graphicType = Config.CIRCLE_GRAPHIC;

    @ColorAttribute()
    private accessor fillColor = 0xff00ff;
    @AlphaAttribute()
    private accessor fillAlpha = 0.5;
    @ColorAttribute()
    private accessor strokeColor = 0xff00ff;
    @AlphaAttribute()
    private accessor strokeAlpha = 0.5;
    @NumberAttribute({ min: 0, animatable: false })
    private accessor strokeWidth = 0;
    @NumberAttribute({ min: 0 })
    private accessor radius = 10;
    @NumberAttribute({ animatable: false })
    private accessor positionX = 0;
    @NumberAttribute({ animatable: false })
    private accessor positionY = 0;

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    override get readonlyProperties() {
        return [];
    }

    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    }

    override get editableProperties() {
        return super.editableProperties.concat([
            'fillColor',
            'fillAlpha',
            'strokeColor',
            'strokeAlpha',
        ]);
    }
}
